import React, { useState, useEffect } from "react";

import axios from "axios";

import { Loading, PageListItem } from "../../components";
import { isMobile } from "react-device-detect";

const RecentEvents = ({ className = "" }) => {
  const [pages, setPages] = useState();

  useEffect(() => {
    const loadData = async () => {
      const { data } = await axios.post("/api/pages/search", {
        sort: { field: "created_at", direction: "desc" },
        paging: { limit: 4, offset: 0 },
        type: "event",
      });

      setPages(data.items);
    };

    loadData();
  }, []);

  if (!pages) {
    return <Loading type="table" showText={false} />;
  }

  return (
    <div className={`${isMobile ? "mx-0" : ""} row`}>
      <div className="col-lg-6">
        {pages[0] && (
          <PageListItem page={pages[0]} showButton={false} height={319} />
        )}
      </div>

      <div className="col-lg-6">
        {pages[1] && (
          <PageListItem page={pages[1]} showButton={false} height={319} />
        )}
      </div>
    </div>
  );
};

export default RecentEvents;
